import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	order: null,
	meta: {}
};

export default function paymentCallbackPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.VERIFY_PAYMENT_CALLBACK_REQUEST:
		case ActionTypes.VERIFY_PAYMENT_CALLBACK_ERROR:
		case ActionTypes.VERIFY_PAYMENT_CALLBACK_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_PAYMENT_CALLBACK_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
